const formatStatus = (status: string | null): string => {
  if (!status) return "";
  return status
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const StatusChip = ({ status }: { status: string | null }) => {
  const displayStatus = formatStatus(status);

  let baseClasses =
    "px-3 py-1 rounded-full text-sm font-medium inline-block ";

  let colorClasses = "";

  switch (status?.toLowerCase()) {
    case "Pending".toLowerCase():
      colorClasses = "bg-yellow-100 text-yellow-800";
      break;
    case "Under Investigation".toLowerCase():
      colorClasses = "bg-blue-100 text-blue-800";
      break;
    case "Draft Charge".toLowerCase():
      colorClasses = "bg-purple-100 text-purple-800";
      break;
    case "Under Litigation".toLowerCase():
      colorClasses = "bg-orange-100 text-orange-800";
      break;
    case "Council Decision".toLowerCase():
      colorClasses = "bg-green-100 text-green-800";
      break;
    case "Closed".toLowerCase():
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Rejected".toLowerCase():
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Revise".toLowerCase():
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "respond_back".toLowerCase():
      colorClasses = "bg-red-100 text-red-800";
      break;
    case "Approved".toLowerCase():
      colorClasses = "bg-green-500 text-white";
      break;
    case "Approve".toLowerCase():
      colorClasses = "bg-green-500 text-white";
      break;
    case "approved".toLowerCase():
      colorClasses = "bg-green-500 text-white";
      break;
    case "Confirmed".toLowerCase():
      colorClasses = "bg-green-500 text-white";
      break;
    default:
      colorClasses = "bg-gray-100 text-gray-800";
  }

  return <span className={`${baseClasses} ${colorClasses}`}>{displayStatus}</span>;
};

